import React, { useLayoutEffect, useRef } from 'react';
import LuckyOrangeScript from '../utils/analytics/LuckyOrangeScript';
import CookieConsentBar from './CookieConsentBar';
import { LoadingProvider } from '../contexts/LoadingContext';
import { cleanupScrollSmoother } from '../utils/scrollSmoother';
import { cleanupAllGSAP } from '../utils/gsapCleanup';
import { initializeScrollPositionManager } from '../utils/sectionBasedScrollManager';

import { ToastContainer } from 'react-toastify';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ENV = process.env.NODE_ENV || 'development';

const Layout = ({ children }) => {
  const container = useRef();

  useLayoutEffect(() => {
    if (typeof window === 'undefined') return;

    // Initialize scroll position manager to preserve scroll position across reloads
    const cleanupScrollManager = initializeScrollPositionManager();

    // Make cleanup functions globally available for debugging
    window.cleanupGSAP = cleanupAllGSAP;
    window.cleanupScrollSmoother = cleanupScrollSmoother;

    // Cleanup all GSAP instances when component unmounts or re-renders
    return () => {
      cleanupAllGSAP();
      if (cleanupScrollManager) {
        cleanupScrollManager();
      }
    };
  }, []);

  return (
    <LoadingProvider>
      {/* Lucky Orange Tracking Code */}
      {ENV === 'production' && <LuckyOrangeScript />}

      <CookieConsentBar />

      <main ref={container}>
        <ToastContainer
          className="toast-message"
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          draggable
          pauseOnHover
        />

        <div id="smooth-wrapper">
          <div id="smooth-content">{children}</div>
        </div>
      </main>
    </LoadingProvider>
  );
};

export default Layout;
